export default {"src":"/_next/static/media/performance.e90beb40.svg","height":142,"width":241,"blurWidth":0,"blurHeight":0};